import * as React from "react";
import { IconProps } from "ztypes/icon-props";

const IconPlus: React.FunctionComponent<IconProps> = (props) => {
  return (
    <svg
      className={props.className}
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="0.75"
        y="0.75"
        width="22.5"
        height="22.5"
        rx="11.25"
        stroke="#3D3D3D"
        strokeOpacity="0.6"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 12.75V18H12.75V12.75H18V11.25H12.75V6H11.25V11.25H6V12.75H11.25Z"
        fill="#3D3D3D"
      />
    </svg>
  );
};

export default IconPlus;
